<template>
    <div class="feedback-step question--yes-no">
        <!-- <div class="heading-third--grey ">{{ feedbackData.text }}</div> -->
        <div class="heading-third--grey ">{{ feedbackData.text }}</div>
        <QuestionError :showEmptyError="showEmptyError" />
        <div class="yesno-buttons">
            <span class="button-ths button-ths-50 button-ths--link-pink" :class="[{'selected': yesNo === 1}]" @click="selectYesNo(1)">{{ $t('yes') }}</span>
            <span class="button-ths button-ths-50 button-ths--link-pink" :class="[{'selected': yesNo === 0}]" @click="selectYesNo(0)">{{ $t('no') }}</span>
        </div>
    </div>
</template>

<script>
    import QuestionError from '@/components/QuestionError.vue'

    export default {
        name: "StepYesNo",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {},
            showEmptyError: {
                type: Boolean,
                default: false
            }
        },
        components: {QuestionError},
        data() {
            return {
                yesNo: '',
                showFeedback: false,
            }
        },
        methods: {
            selectYesNo(i) {
                if (i === this.yesNo) {
                    this.yesNo = '';
                    this.$emit('updateProgress', false);
                }
                else { 
                    this.yesNo = i;
                    this.$emit('updateProgress', true)
                }
                /* this.$emit('showFeedback', this.yesNo) */
                /* this.$emit('hideError') */
            }
        }, 
        mounted() {
            if (this.savedAnswer) {
                this.yesNo = this.savedAnswer.value;
            }
        },
        computed: {
            questionCopy() {
                return 'question.' + this.feedbackData.id
            },
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({value: this.yesNo}),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.yesNo === '') ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.yesNo = this.savedAnswer.value;
                    if (this.yesNo)
                        this.$emit('showFeedback', this.yesNo)
                }
                else {
                    this.yesNo = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.yesNo = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
